export default __webpack_public_path__ + "static/media/PFSquareSansProBoldItalic_35481.0f8bd071.ttf";